import vue from 'vue'
import SessionStorage from '@/services/session-storage'

const state = {
    configuracao: SessionStorage.getObject('configuracao') || {}
};

const mutations = {
    SET_CONFIGURACAO(state, data) {
        SessionStorage.setObject('configuracao', data)
        state.configuracao = data;
        return state.configuracao
        
    }
};

const actions = {
    setConfiguracao(context) {
        vue.http.get('api/configuracoes').then((response) => {
            context.commit('SET_CONFIGURACAO', response.data.configuracao)    
        })
    }
};

export default {
    state,
    mutations,
    actions
}
